import { render, staticRenderFns } from "./addEditEntity.vue?vue&type=template&id=1900cbd7"
import script from "./addEditEntity.vue?vue&type=script&lang=js"
export * from "./addEditEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports